import React from 'react';
import { useParams, useHistory } from 'react-router-dom';
import { isB2BMode } from '../../utils/bookingsBase';

export default function PaiementRefuse() {
  const { bookingId } = useParams();
  const history = useHistory();
  const b2b = isB2BMode();

  return (
    <div className="container " style={{ paddingTop: '10rem' }}>
      <div className="text-center">
        <h2 className="text-danger fw-semibold">Paiement refusé</h2>
        <p className="text-muted mt-2">
          Votre paiement n’a pas pu être confirmé. Aucun débit n’a été finalisé.
        </p>

        <div className="card mt-4 mx-auto" style={{ maxWidth: 560 }}>
          <div className="card-body">
            <div className="d-flex justify-content-between border-bottom py-2">
              <span className="text-muted">Réservation</span>
              <span className="fw-semibold">{bookingId}</span>
            </div>

            <div className="mt-3 small text-muted">
              Vous pouvez réessayer le paiement ou contacter notre support si le problème
              persiste.
            </div>

            <div className="d-grid gap-2 mt-4">
              <button
                className="btn btn-primary"
                onClick={() =>
                  history.push(b2b ? `/b2b/paiement/${bookingId}` : `/paiement/${bookingId}`)
                }
              >
                Réessayer le paiement
              </button>

              <button
                className="btn btn-outline-secondary"
                onClick={() => history.push(b2b ? `/b2b/selection` : `/selection`)}
              >
                Retour
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
